var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlockedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.127,
    height: 19.855,
    viewBox: "0 0 15.127 19.855",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6734",
    "data-name": "Path 6734",
    d: "M11.564,12.345a1.891,1.891,0,1,0,1.891,1.891A1.9,1.9,0,0,0,11.564,12.345Zm5.673-4.727h-.945V5.727a4.727,4.727,0,0,0-9.3-1.182.947.947,0,0,0,1.834.473,2.834,2.834,0,0,1,5.578.709V7.618H5.891A1.9,1.9,0,0,0,4,9.509v9.455a1.9,1.9,0,0,0,1.891,1.891H17.236a1.9,1.9,0,0,0,1.891-1.891V9.509A1.9,1.9,0,0,0,17.236,7.618Zm0,10.4a.948.948,0,0,1-.945.945H6.836a.948.948,0,0,1-.945-.945V10.455a.948.948,0,0,1,.945-.945h9.455a.948.948,0,0,1,.945.945Z",
    transform: "translate(-4 -1)",
    fill: "#71cf48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockedIcon);
export default __webpack_public_path__ + "static/media/unlocked_icon.0753a0683fafca6b153fba932fc54da5.svg";
export { ForwardRef as ReactComponent };